export default function globalLanguageMenu() {


    function LangResizeMenu() {
        $(".global-icon").on("click", () => {
            $('.suggest-lang-pop').hide();
            let windowWidth = $(window).width();
            if (windowWidth > 767) {
                $(".global-language").slideToggle("fast");
            }else{
                $('html').toggleClass('overflow');
                $('body').toggleClass('show-Mlang');
            };
        });
    }
    LangResizeMenu();
}
